import React, { Suspense, lazy, useCallback, useState } from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";

import Nav from "./components/chrome/Nav";
import Footer from "./components/chrome/Footer";
import ScrollToTop from "./components/chrome/ScrollToTop";
import ScrollProgress from "./components/chrome/ScrollProgress";
import CommandPalette from "./components/chrome/CommandPalette";
import Toast from "./components/chrome/Toast";
import { useTheme } from "./lib/hooks";

// Home ships in the main bundle; everything else is fetched on demand.
import Home from "./pages/Home";

const Resume = lazy(() => import("./pages/Resume"));
const Projects = lazy(() => import("./pages/Projects"));
const ContactPage = lazy(() => import("./pages/ContactPage"));
const Watermark = lazy(() => import("./pages/Watermark"));
const NotFound = lazy(() => import("./pages/NotFound"));

const RouteFallback = () => (
  <div className="route-loader">
    <span className="spinner" aria-hidden="true" />
    <span className="sr-only">Loading</span>
  </div>
);

const App = () => {
  const [theme, toggleTheme] = useTheme();
  const [toast, setToast] = useState("");
  const clearToast = useCallback(() => setToast(""), []);

  return (
    <BrowserRouter>
      <ScrollToTop />
      <ScrollProgress />

      <a className="skip-link" href="#main">Skip to content</a>

      <Nav theme={theme} onToggleTheme={toggleTheme} />

      <div className="page">
        <main className="page__body" id="main">
          <Suspense fallback={<RouteFallback />}>
            <Routes>
              <Route path="/" element={<Home onToggleTheme={toggleTheme} />} />
              <Route path="/resume" element={<Resume />} />
              <Route path="/projects" element={<Projects />} />
              <Route path="/projects/watermark" element={<Watermark />} />
              <Route path="/contact" element={<ContactPage />} />
              {/* Legacy paths from the previous site. */}
              <Route path="/submit" element={<Navigate to="/contact" replace />} />
              <Route path="/subscribed" element={<Navigate to="/contact" replace />} />
              <Route path="/comingsoon" element={<Navigate to="/projects" replace />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </Suspense>
        </main>
        <Footer />
      </div>

      <CommandPalette theme={theme} onToggleTheme={toggleTheme} onToast={setToast} />
      <Toast message={toast} onDone={clearToast} />
    </BrowserRouter>
  );
};

export default App;
